import instance from 'Src/common/utilities/axios_util';
import { APPLY_CHANGES, IGNORE_CHANGES, CREATE_RECORD_URL, TRACK_ACTIONS_API_PATH } from '../endpoints';

export const applyChanges = (changes) => instance.patch(APPLY_CHANGES, { changes });

export const ignoreChanges = (changes) => instance.patch(IGNORE_CHANGES, { changes });

export const createRecord = (data) => instance.post(CREATE_RECORD_URL, data);

export const trackEvent = (data) => instance.post(TRACK_ACTIONS_API_PATH, data);
